import { DependenciesInjection } from "app/di/DependencyInjection";
import { B2CPartnerManagementViewModel } from "../presentation/b2cProvider/viewModel/B2CPartnerManagementViewModel";
import { B2CPartnerManagementImpl } from "../data/B2CPartnerManagementImpl";
import { IB2CPartnerManagementRepository } from "../domain/repositories/IB2CPartnerManagementRepository";
import { B2CPartnerManagementUseCase } from "../domain/useCases/B2CPartnerManagementUseCase";
import { PartnerManagementToken } from "./PartnerManagementToken";

export class PartnerManagementInjection {
  private static initB2CProvider() {
    DependenciesInjection.register<IB2CPartnerManagementRepository>(
      PartnerManagementToken.IB2CPartnerManagementRepository,
      B2CPartnerManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<B2CPartnerManagementUseCase>(
      PartnerManagementToken.B2CPartnerManagementUseCase,
      B2CPartnerManagementUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<B2CPartnerManagementViewModel>(
      PartnerManagementToken.B2CPartnerManagementViewModel,
      B2CPartnerManagementViewModel,
      "viewModel",
    );
  }

  static initInjections() {
    this.initB2CProvider();
  }

  static getB2CRepo() {
    return DependenciesInjection.getRepo<IB2CPartnerManagementRepository>(
      PartnerManagementToken.IB2CPartnerManagementRepository,
    );
  }

  static getB2CUseCase() {
    return DependenciesInjection.getRepo<B2CPartnerManagementUseCase>(
      PartnerManagementToken.B2CPartnerManagementUseCase,
    );
  }
}
